import { PaymentsPageVariant } from '../../providers';

export * from './invoices';
export * from './refunds';

export const isPaymentsAppVariant = (variant: PaymentsPageVariant) => variant === 'payments-app';
